// Llamada a Strapi
export const getStrapiData = async (url: string, query: any) => {
  const { find } = useStrapi()
  const { locale } = useI18n()
  let content: any
  try {
    const data: any = await find(url, query)
    content = data?.data?.attributes
  } catch (error) {
    console.error('Error llamda Strapi', error)
    try {
      const contentData = await $fetch(`/strapi/${locale.value}/${url}`)
      content = extractStrapiData(contentData?.[0])
    } catch (fetchError) {
      console.error('Error llamda de respaldo', fetchError)
    }
  }
  return content
}

export const extractStrapiData = (response: any) => {
  return response?.data?.attributes
}

export const getStrapiDataBy = async (url: string, by: string, query: any, locale: string) => {
  const runtimeConfig = useRuntimeConfig()
  let content: any
  try {
    const contentData: any = await $fetch(`${runtimeConfig.public.STRAPI_CLIENT_URL}/api/${url}?filters[${by}]=${query}&locale=${locale}`)
    content = contentData?.data?.[0]?.attributes
  } catch (error) {
    console.error('Error llamda Strapi', error)
    try {
      const contentData = await $fetch(`/strapi/${locale}/${url}`)
      content = extractStrapiData(contentData?.[0])
    } catch (fetchError) {
      console.error('Error llamda de respaldo', fetchError)
      throw new Error('No se pudo obtener los datos de Strapi')
    }
  }
  return content
}

export const getImageSrc = (strapiData: StrapiData, path: string) => {
  const provider = strapiData?.attributes?.provider
  const image = strapiData?.attributes
  if (provider === "s3Provider") {
    return `${path}/${image.name}` // Si es S3, devuelve el nombre
  }

  return image.url // Si es Strapi, usa su URL
}